import { render, staticRenderFns } from "./processing-list-details.vue?vue&type=template&id=4424c9de&scoped=true"
import script from "./processing-list-details.vue?vue&type=script&lang=js"
export * from "./processing-list-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4424c9de",
  null
  
)

export default component.exports